// import taxes from "../../../taxes.json";

// const forms = [
//   {
//     name: "Inventory",
//     className: "bg-white p-4 rounded-md p-8 w-[90%] mx-auto",
//     options: [
//       {
//         name: "Batch number",
//         type: "input",
//         form: {
//           type: "text",
//           name: "number",
//           placeholder: "Batch number",
//           class: "",
//           value: "",
//           required: false,
//         },
//       },
//       {
//         name: "Product",
//         type: "selectandadd",
//         path: "/app/products/add",
//         form: {
//           name: "product",
//           allowClear: true,
//           showSearch: true,
//           filterOption: false,
//           placeholder: "Product",
//           api: "get-all-products",
//           options: null,
//           value: null,
//           required: true,
//         },
//       },
//       {
//         name: "Barcode",
//         type: "input",
//         form: {
//           type: "text",
//           name: "barcode",
//           placeholder: "Batch barcode",
//           class: "",
//           value: "",
//           required: false,
//         },
//       },
//       {
//         name: "Supplier",
//         type: "selectandadd",
//         path: "/app/suppliers/add",
//         form: {
//           name: "supplier",
//           allowClear: true,
//           showSearch: true,
//           filterOption: false,
//           placeholder: "Supplier",
//           api: "get-all-suppliers",
//           options: null,
//           value: null,
//           required: false,
//         },
//       },
//     ],
//   },
//   {
//     name: "Pricing",
//     options: [
//       {
//         name: "Purchase price",
//         type: "input",
//         form: {
//           type: "number",
//           name: "purchase_price",
//           placeholder: "Batch purchase price",
//           value: "",
//           required: true,
//         },
//       },
//       {
//         name: "Price/unit",
//         type: "input",
//         form: {
//           type: "number",
//           name: "price_per_unit",
//           placeholder: "Price per unit",
//           value: "",
//           required: true,
//         },
//       },
//       {
//         name: "Sale/Retail price",
//         type: "input",
//         form: {
//           type: "number",
//           name: "sale_price",
//           placeholder: "Batch sale price",
//           value: "",
//           required: true,
//         },
//       },
//       {
//         name: "Wholesale price",
//         type: "input",
//         form: {
//           type: "number",
//           name: "wholesale_price",
//           placeholder: "Wholesale price",
//           value: "",
//           required: false,
//         },
//       },
//       {
//         name: "Tax",
//         type: "select",
//         form: {
//           name: "tax",
//           allowClear: false,
//           placeholder: "Tax",
//           value: 0,
//           options: taxes?.map((value, index) => ({
//             value: value?.value,
//             label: value?.label,
//           })),
//           required: false,
//         },
//       },
//     ],
//   },
//   {
//     name: "Stock",
//     options: [
//       {
//         name: "Stock",
//         type: "input",
//         form: {
//           type: "number",
//           name: "stock",
//           placeholder: "Batch stock",
//           class: "",
//           value: "",
//           required: false,
//         },
//       },
//     ],
//   },
//   {
//     name: "Date",
//     options: [
//       {
//         name: "Manufacture Date",
//         type: "date",
//         form: {
//           type: "text",
//           name: "manufacture_date",
//           placeholder: "Batch manufacture date",
//           class: "",
//           value: "",
//           required: false,
//         },
//       },
//       {
//         name: "Expiry Date",
//         type: "date",
//         form: {
//           type: "text",
//           name: "expiry_date",
//           placeholder: "Batch expiry date",
//           class: "",
//           value: "",
//           required: false,
//         },
//       },
//     ],
//   },
//   {
//     name: "Status",
//     options: [
//       {
//         name: "Status",
//         type: "select",
//         form: {
//           name: "status",
//           allowClear: false,
//           placeholder: "Status",
//           value: 1,
//           options: [
//             {
//               value: 1,
//               label: "Active",
//             },
//             {
//               value: 0,
//               label: "In-active",
//             },
//           ],
//           required: false,
//         },
//       },
//     ],
//   },
// ];

// export default forms;



//V3


import taxes from "../../../taxes.json";
import { get_all_products } from "../../../../Controllers/Products/Products";
//import { get_all_suppliers } from "../../../../Controllers/Suppliers/Suppliers";

// ---------------------------------------------------
// 1. Product search (async)
const loadProductOptions = async (search = "") => {
  try {
    const res = await get_all_products({
      search: search.trim(),
      page: 1,
      limit: 50,
      status: 1,
    });

    if (res?.status && res?.data?.data) {
      return res.data.data.map(p => ({
        value: p._id,
        label: `${p.name}${p.barcode ? ` (${p.barcode})` : ""}`.trim(),
      }));
    }
    return [];
  } catch (err) {
    console.error("loadProductOptions error:", err);
    return [];
  }
};

// ---------------------------------------------------
// 2. Supplier search
// const loadSupplierOptions = async (search = "") => {
//   try {
//     const res = await get_all_suppliers({
//       search: search.trim(),
//       page: 1,
//       limit: 50,
//     });

//     if (res?.status && res?.data?.data) {
//       return res.data.data.map(s => ({
//         value: s._id,
//         label: s.name,
//       }));
//     }
//     return [];
//   } catch (err) {
//     console.error("loadSupplierOptions error:", err);
//     return [];
//   }
// };

const forms = [
  {
    name: "Inventory",
    className: "bg-white p-4 rounded-md p-8 w-[90%] mx-auto",
    options: [
      {
        name: "Batch number",
        type: "input",
        form: {
          type: "text",
          name: "number",
          placeholder: "Batch number",
          class: "",
          value: "",
          required: false,
        },
      },
      {
        name: "Product",
        type: "selectandadd",
        path: "/app/products/add",
        form: {
          name: "product",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Search product by name or barcode...",
          loadOptions: loadProductOptions,
          options: null,
          value: null,
          required: true,
        },
      },
      {
        name: "Barcode",
        type: "input",
        form: {
          type: "text",
          name: "barcode",
          placeholder: "Batch barcode",
          class: "",
          value: "",
          required: false,
        },
      },
      {
        name: "Supplier",
        type: "selectandadd",
        path: "/app/suppliers/add",
        form: {
          name: "supplier",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Search supplier...",
          // loadOptions: loadSupplierOptions,
          api: "get-all-suppliers",
          options: null,
          value: null,
          required: false,
        },
      },
    ],
  },
  {
    name: "Pricing",
    options: [
      {
        name: "Purchase price",
        type: "input",
        form: {
          type: "number",
          name: "purchase_price",
          placeholder: "Batch purchase price",
          value: "",
          required: true,
        },
      },
      {
        name: "Price/unit",
        type: "input",
        form: {
          type: "number",
          name: "price_per_unit",
          placeholder: "Price per unit",
          value: "",
          required: true,
        },
      },
      {
        name: "Sale/Retail price",
        type: "input",
        form: {
          type: "number",
          name: "sale_price",
          placeholder: "Batch sale price",
          value: "",
          required: true,
        },
      },
      {
        name: "Wholesale price",
        type: "input",
        form: {
          type: "number",
          name: "wholesale_price",
          placeholder: "Wholesale price",
          value: "",
          required: false,
        },
      },
      {
        name: "Tax",
        type: "select",
        form: {
          name: "tax",
          allowClear: false,
          placeholder: "Tax",
          value: 0,
          options: taxes?.map((value) => ({
            value: value?.value,
            label: value?.label,
          })),
          required: false,
        },
      },
    ],
  },
  {
    name: "Stock",
    options: [
      {
        name: "Stock",
        type: "input",
        form: {
          type: "number",
          name: "stock",
          placeholder: "Batch stock",
          class: "",
          value: "",
          required: false,
        },
      },
    ],
  },
  {
    name: "Date",
    options: [
      {
        name: "Manufacture Date",
        type: "date",
        form: {
          type: "text",
          name: "manufacture_date",
          placeholder: "Batch manufacture date",
          class: "",
          value: "",
          required: false,
        },
      },
      {
        name: "Expiry Date",
        type: "date",
        form: {
          type: "text",
          name: "expiry_date",
          placeholder: "Batch expiry date",
          class: "",
          value: "",
          required: false,
        },
      },
    ],
  },
  {
    name: "Status",
    options: [
      {
        name: "Status",
        type: "select",
        form: {
          name: "status",
          allowClear: false,
          placeholder: "Status",
          value: 1,
          options: [
            { value: 1, label: "Active" },
            { value: 0, label: "In-active" },
          ],
          required: false,
        },
      },
    ],
  },
];

export default forms;